import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {SearchService_GetSearchResultsPageBulkLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.grpc.lazy';
import {GetSearchResultsPageBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {useFullSession} from '@aboutyou/user';
import {PRODUCTS_PER_PAGE} from '../../../features/ProductStream/constants';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useProtoProductImageType} from '../../../shared-deprecated/useProductImageType';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useSearchToken} from '../SearchPageResolver';
import {useCategoryIdentifier} from './useCategoryIdentifier';

const useSearchPageBulkSection = <
  Section extends keyof GetSearchResultsPageBulkResponse,
>(
  sectionName: Section,
) => {
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const preferredImage = useProtoProductImageType();
  const searchToken = useSearchToken();
  const reductionsState = useReductionsStateRequestParameter();
  const session = useFullSession();
  const categoryIdentifier = useCategoryIdentifier();

  return useGrpcRequest(
    SearchService_GetSearchResultsPageBulkLazy,
    {
      searchToken,
      session,
      reductionsState,
      targetGroup: targetGroupIdentifier,
      elementCount: PRODUCTS_PER_PAGE,
      appliedFilters: {
        filters: appliedFilters,
      },
      preferredProductImageType: preferredImage,
      category: categoryIdentifier ?? null,
    },
    {
      section: sectionName,
    },
  );
};

export const useSearchPageMetaSection = () => {
  return useSearchPageBulkSection('meta');
};

export const useSearchPageFiltersSection = () => {
  return useSearchPageBulkSection('filters');
};

export const useSearchPageStreamSection = () => {
  const request = useSearchPageBulkSection('stream');

  const nextState = request.data?.continuationToken;
  const items = request.data?.sections;

  return {
    ...request,
    data: request.data
      ? {
          ...request.data,
          nextState,
          items,
        }
      : undefined,
  };
};

export const useSearchCategoryTreeSection = () => {
  return useSearchPageBulkSection('categoryTree');
};

export const useSearchNavigationHeaderSection = () => {
  return useSearchPageBulkSection('navigationHeader');
};
